import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { ProductPreview } from "../../../domain/projections/ProductPreview";
import { ProductRepositoryImpl } from "../../domain/productRepositoryImpl/ProductRepositoryImpl";
import { queryClientContext } from "../hooks/useQueryClient";
import { useStaticInfo } from "../hooks/useStaticInfo";

const productRepo = ProductRepositoryImpl.getInstance();

const useGetLookAndLikeProducts = () => {
  const {
    session: { auth },
    apiUrl,
  } = useStaticInfo();

  const queryClient = useContext(queryClientContext);

  const { isLoading, data } = useQuery(
    {
      queryKey: ["useGetLookAndLikeProducts", auth],
      queryFn: async () => {
        return await productRepo.getLookAndLikeProducts(auth, apiUrl);
      },
      enabled: Boolean(auth),
    },
    queryClient,
  );

  return { isLoading, products: data || ([] as ProductPreview[]) };
};

export { useGetLookAndLikeProducts };
